import { Injectable, NgZone, inject } from '@angular/core';

import { BaseGoogleApiLoader } from '../../abstractions/base.google-api-loader';

declare const google: any;

@Injectable()
export class AsyncCallbackGoogleApiLoader extends BaseGoogleApiLoader {
    protected zone = inject(NgZone);
    
    constructor() {
        super();
    }

    load(): void {
        if (typeof window === 'undefined') {
            return;
        }

        if (this.isLoaded()) {
            this.api.next(google.maps);
        } else if (!document.querySelector(this.mapSelector)) {
            const anyWindow = window as any;

            if (!anyWindow.googleMapRef) {
                anyWindow.googleMapRef = [];
            }

            anyWindow.googleMapRef.push({ zone: this.zone, componentFn: () => this.api.next(google.maps) });
            this.addGoogleMapsApi();
        }
    }

    private addGoogleMapsApi(): void {
        const anyWindow = window as any;
        const script = document.createElement('script');

        if (!anyWindow.initThumediMap) {
            anyWindow.initThumediMap = () => {
                anyWindow.googleMapRef.forEach((googleMapRef: any) => {
                    googleMapRef.zone.run(() => { googleMapRef.componentFn(); });
                });
                anyWindow.googleMapRef.splice(0, anyWindow.googleMapRef.length);
            };
        }

        script.id = this.mapSelector;
        script.src = this.apiUrl;

        document.querySelector('body').appendChild(script);
    }
}
